import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import Amplify from 'aws-amplify';

import { environment } from '@env/environment';
import { Logger } from '@core';

const log = new Logger('App');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    Amplify.configure({
      Auth: environment.auth
    });
  }

  ngOnInit() {
    // Setup logger
    if (environment.production) Logger.enableProductionMode();

    log.debug('init');
  }

  ngOnDestroy() {
    // Needed for automatic unsubscribe with untilDestroyed
  }
}
